import { createSlice } from '@reduxjs/toolkit';
import { Information } from 'types';
import { getHistoryReceiving, getHistorySending } from './thunk';

interface InitialState {
  received: {
    notifications: Information[];
    count: number;
    nextPage: number | null;
    currentPage: number;
    prevPage: number | null;
    lastPage: number | null;
    loading: boolean;
  };
  sent: {
    notifications: Information[];
    count: number;
    nextPage: number | null;
    currentPage: number;
    prevPage: number | null;
    lastPage: number | null;
    loading: boolean;
  };
}

const initialState: InitialState = {
  received: {
    notifications: [],
    count: 0,
    nextPage: 0,
    prevPage: 0,
    lastPage: 0,
    currentPage: 0,
    loading: true,
  },
  sent: {
    nextPage: 0,
    prevPage: 0,
    lastPage: 0,
    currentPage: 0,
    notifications: [],
    count: 0,
    loading: true,
  },
};

export const notificationsSlice = createSlice({
  name: 'notifications-page',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHistoryReceiving.pending, (state) => {
      state.received.loading = true;
    });
    builder.addCase(getHistoryReceiving.fulfilled, (state, { payload }) => {
      state.received = {
        notifications: payload.notifications,
        count: payload.count,
        currentPage: payload.currentPage + 1,
        nextPage: payload.nextPage,
        prevPage: payload.prevPage,
        lastPage: payload.lastPage,
        loading: false,
      };
    });
    builder.addCase(getHistoryReceiving.rejected, (state) => {
      state.received.notifications = initialState.received.notifications;
      state.received.count = initialState.received.count;
      state.received.currentPage = initialState.received.currentPage;
      state.received.nextPage = initialState.received.nextPage;
      state.received.prevPage = initialState.received.prevPage;
      state.received.lastPage = initialState.received.lastPage;
      state.received.loading = false;
    });

    builder.addCase(getHistorySending.pending, (state) => {
      state.sent.loading = true;
    });
    builder.addCase(getHistorySending.fulfilled, (state, { payload }) => {
      state.sent = {
        notifications: payload.notifications,
        count: payload.count,
        currentPage: payload.currentPage + 1,
        nextPage: payload.nextPage,
        prevPage: payload.prevPage,
        lastPage: payload.lastPage,
        loading: false,
      };
    });
    builder.addCase(getHistorySending.rejected, (state) => {
      state.sent.notifications = initialState.sent.notifications;
      state.sent.count = initialState.sent.count;
      state.sent.currentPage = initialState.sent.currentPage;
      state.sent.nextPage = initialState.sent.nextPage;
      state.sent.prevPage = initialState.sent.prevPage;
      state.sent.lastPage = initialState.sent.lastPage;
      state.sent.loading = false;
    });
  },
});

export default notificationsSlice.reducer;
